import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2, Clock, Calendar, MessageSquare, Mail, Phone } from 'lucide-react';
export function ContactPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success'>('idle');
  const [formData, setFormData] = useState({
    name: '',
    business: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormStatus('submitting');
    // Simulate form submission
    setTimeout(() => {
      setFormStatus('success');
      // Reset form after a delay
      setTimeout(() => setFormStatus('idle'), 4000);
    }, 1500);
  };
  return <div className="pt-24 min-h-screen flex flex-col bg-[#0a0a0a]" data-id="element-399">
      {/* Page Header */}
      <section className="py-20 border-b border-white/[0.05]" data-id="element-400">
        <div className="container mx-auto px-6 md:px-12 max-w-4xl text-center" data-id="element-401">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-402">
            <h1 className="text-4xl md:text-5xl font-medium text-white mb-6 tracking-tight" data-id="element-403">
              Hablemos de tu proyecto
            </h1>
            <p className="text-lg text-gray-400 leading-relaxed font-normal max-w-2xl mx-auto" data-id="element-404">
              Da el primer paso para transformar la presencia digital de tu
              negocio. Sin compromisos, solo una conversación sobre cómo podemos
              ayudarte a crecer.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 flex-1" data-id="element-405">
        <div className="container mx-auto px-6 md:px-12 max-w-5xl" data-id="element-406">
          <div className="card-premium !rounded-3xl flex flex-col lg:flex-row !overflow-hidden" data-id="element-407">
            {/* Left Side - Info */}
            <div className="w-full lg:w-5/12 p-8 lg:p-12 flex flex-col bg-[#0a0a0a] border-r border-white/[0.05]" data-id="element-408">
              <motion.div initial={{
              opacity: 0,
              x: -10
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.5,
              delay: 0.1
            }} className="h-full flex flex-col" data-id="element-409">
                <h2 className="text-2xl font-medium text-white mb-8 tracking-tight" data-id="element-410">
                  ¿Qué pasa después?
                </h2>

                <div className="space-y-8 mb-12 flex-1" data-id="element-411">
                  <div className="flex gap-4" data-id="element-412">
                    <div className="w-10 h-10 rounded-xl bg-white/[0.03] border border-white/[0.05] flex items-center justify-center shrink-0 text-gray-400" data-id="element-413">
                      <Clock size={18} data-id="element-414" />
                    </div>
                    <div data-id="element-415">
                      <h4 className="text-white font-medium mb-1 text-[15px]" data-id="element-416">
                        Revisión rápida
                      </h4>
                      <p className="text-sm text-gray-500 leading-relaxed" data-id="element-417">
                        Analizamos la información de tu negocio en menos de 24
                        horas laborables.
                      </p>
                    </div>
                  </div>

                  <div className="flex gap-4" data-id="element-418">
                    <div className="w-10 h-10 rounded-xl bg-white/[0.03] border border-white/[0.05] flex items-center justify-center shrink-0 text-gray-400" data-id="element-419">
                      <MessageSquare size={18} data-id="element-420" />
                    </div>
                    <div data-id="element-421">
                      <h4 className="text-white font-medium mb-1 text-[15px]" data-id="element-422">
                        Primer contacto
                      </h4>
                      <p className="text-sm text-gray-500 leading-relaxed" data-id="element-423">
                        Te contactamos para presentarnos y entender mejor tus
                        necesidades específicas.
                      </p>
                    </div>
                  </div>

                  <div className="flex gap-4" data-id="element-424">
                    <div className="w-10 h-10 rounded-xl bg-white/[0.03] border border-white/[0.05] flex items-center justify-center shrink-0 text-gray-400" data-id="element-425">
                      <Calendar size={18} data-id="element-426" />
                    </div>
                    <div data-id="element-427">
                      <h4 className="text-white font-medium mb-1 text-[15px]" data-id="element-428">
                        Llamada de diagnóstico
                      </h4>
                      <p className="text-sm text-gray-500 leading-relaxed" data-id="element-429">
                        Agendamos una breve reunión gratuita para proponerte la
                        mejor solución.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="p-5 bg-white/[0.02] rounded-xl border border-white/[0.05]" data-id="element-430">
                  <div className="flex items-center gap-2 mb-2" data-id="element-431">
                    <CheckCircle2 className="text-brand-emerald" size={16} data-id="element-432" />
                    <span className="text-white font-medium text-sm" data-id="element-433">
                      100% Confidencial
                    </span>
                  </div>
                  <p className="text-[13px] text-gray-500" data-id="element-434">
                    Tus datos están seguros con nosotros. Nunca enviaremos spam
                    ni compartiremos tu información.
                  </p>
                </div>
              </motion.div>
            </div>

            {/* Right Side - Form */}
            <div className="w-full lg:w-7/12 p-8 lg:p-12" data-id="element-435">
              <motion.form initial={{
              opacity: 0,
              x: 10
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.5,
              delay: 0.2
            }} onSubmit={handleSubmit} className="space-y-5" data-id="element-436">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-437">
                  <div className="space-y-1.5" data-id="element-438">
                    <label htmlFor="name" className="text-[12px] font-medium text-gray-400 uppercase tracking-wider" data-id="element-439">
                      Nombre completo *
                    </label>
                    <div className="relative" data-id="element-440">
                      <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none" data-id="element-441">
                        <User size={16} className="text-gray-600" data-id="element-442" />
                      </div>
                      <input type="text" id="name" required value={formData.name} onChange={e => setFormData({
                      ...formData,
                      name: e.target.value
                    })} className="w-full pl-10 pr-4 py-3 rounded-xl border border-white/[0.08] bg-[#0a0a0a] text-white text-sm focus:outline-none focus:border-brand-emerald/50 transition-colors placeholder-gray-600" placeholder="Juan Pérez" data-id="element-443" />
                    </div>
                  </div>

                  <div className="space-y-1.5" data-id="element-444">
                    <label htmlFor="business" className="text-[12px] font-medium text-gray-400 uppercase tracking-wider" data-id="element-445">
                      Nombre del negocio *
                    </label>
                    <input type="text" id="business" required value={formData.business} onChange={e => setFormData({
                    ...formData,
                    business: e.target.value
                  })} className="w-full px-4 py-3 rounded-xl border border-white/[0.08] bg-[#0a0a0a] text-white text-sm focus:outline-none focus:border-brand-emerald/50 transition-colors placeholder-gray-600" placeholder="Ej. Restaurante El Sabor" data-id="element-446" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-447">
                  <div className="space-y-1.5" data-id="element-448">
                    <label htmlFor="email" className="text-[12px] font-medium text-gray-400 uppercase tracking-wider" data-id="element-449">
                      Correo electrónico *
                    </label>
                    <div className="relative" data-id="element-450">
                      <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none" data-id="element-451">
                        <Mail size={16} className="text-gray-600" data-id="element-452" />
                      </div>
                      <input type="email" id="email" required value={formData.email} onChange={e => setFormData({
                      ...formData,
                      email: e.target.value
                    })} className="w-full pl-10 pr-4 py-3 rounded-xl border border-white/[0.08] bg-[#0a0a0a] text-white text-sm focus:outline-none focus:border-brand-emerald/50 transition-colors placeholder-gray-600" placeholder="tu@email.com" data-id="element-453" />
                    </div>
                  </div>

                  <div className="space-y-1.5" data-id="element-454">
                    <label htmlFor="phone" className="text-[12px] font-medium text-gray-400 uppercase tracking-wider" data-id="element-455">
                      Teléfono móvil *
                    </label>
                    <div className="relative" data-id="element-456">
                      <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none" data-id="element-457">
                        <Phone size={16} className="text-gray-600" data-id="element-458" />
                      </div>
                      <input type="tel" id="phone" required value={formData.phone} onChange={e => setFormData({
                      ...formData,
                      phone: e.target.value
                    })} className="w-full pl-10 pr-4 py-3 rounded-xl border border-white/[0.08] bg-[#0a0a0a] text-white text-sm focus:outline-none focus:border-brand-emerald/50 transition-colors placeholder-gray-600" placeholder="+34 600 000 000" data-id="element-459" />
                    </div>
                  </div>
                </div>

                <div className="space-y-1.5" data-id="element-460">
                  <label htmlFor="service" className="text-[12px] font-medium text-gray-400 uppercase tracking-wider" data-id="element-461">
                    ¿A qué se dedica tu negocio? *
                  </label>
                  <select id="service" required value={formData.service} onChange={e => setFormData({
                  ...formData,
                  service: e.target.value
                })} className="w-full px-4 py-3 rounded-xl border border-white/[0.08] bg-[#0a0a0a] text-white text-sm focus:outline-none focus:border-brand-emerald/50 transition-colors appearance-none cursor-pointer" data-id="element-462">
                    <option value="" disabled className="text-gray-500" data-id="element-463">
                      Selecciona una opción
                    </option>
                    <option value="restaurante" data-id="element-464">
                      Restaurante / Cafetería / Hostelería
                    </option>
                    <option value="servicios" data-id="element-465">
                      Servicios (Peluquería, Clínica, Taller, etc.)
                    </option>
                    <option value="tienda" data-id="element-466">Tienda Local / Comercio</option>
                    <option value="marca_personal" data-id="element-467">
                      Marca Personal / Profesional Independiente
                    </option>
                    <option value="otro" data-id="element-468">Otro sector</option>
                  </select>
                </div>

                <div className="space-y-1.5" data-id="element-469">
                  <label htmlFor="message" className="text-[12px] font-medium text-gray-400 uppercase tracking-wider" data-id="element-470">
                    Cuéntanos sobre tu proyecto (Opcional)
                  </label>
                  <textarea id="message" rows={4} value={formData.message} onChange={e => setFormData({
                  ...formData,
                  message: e.target.value
                })} className="w-full px-4 py-3 rounded-xl border border-white/[0.08] bg-[#0a0a0a] text-white text-sm focus:outline-none focus:border-brand-emerald/50 transition-colors resize-none placeholder-gray-600" placeholder="¿Qué objetivo principal quieres conseguir? ¿Tienes web actualmente?..." data-id="element-471"></textarea>
                </div>

                <button type="submit" disabled={formStatus !== 'idle'} className="w-full bg-brand-emerald text-[#0a0a0a] py-3.5 rounded-xl font-medium text-[15px] hover:bg-brand-emeraldLight transition-colors flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed mt-4" data-id="element-472">
                  {formStatus === 'idle' && <>
                      Solicitar mi proyecto
                      <ArrowRight size={18} data-id="element-473" />
                    </>}
                  {formStatus === 'submitting' && 'Procesando...'}
                  {formStatus === 'success' && '¡Enviado con éxito!'}
                </button>
              </motion.form>
            </div>
          </div>
        </div>
      </section>
    </div>;
}